import { post } from '@/utils/ajax';

const contactService = (() => {
    const submitContact = async payload => {
        try {
            const response = await post('/contact/contact_api.php', payload, {
                showError: true
            });
            return response;
        } catch (error) {
            return error;
        }
    };

    return {
        submitContact
    };
})();

export default contactService;
